<template>
  <base-container :isLoading="isLoading">
    <header>
      <!-- <van-nav-bar title="公积金明细查询" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
      <van-cell-group class="cellgrouptop">
        <!-- <van-nav-bar title="挂号记录查询" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
        <van-cell title="当前就诊卡" :value="checkValue" center @click="showList = true" is-link />
        <van-popup v-model="showList" round position="bottom" style="height: 40%; padding-top: 4px;">
          <van-picker title="就诊卡" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
        <van-cell>
          <van-button style="margin-top:7px;" type="info" block round color="#C71D24" @click="registerRecordQuery">查询
          </van-button>
        </van-cell>
      </van-cell-group>
    </header>
    <van-cell-group class="cellgroup" v-for="(record,index) in registerRecordList" :key="index">
      <van-cell>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;">
          <van-col span="6">挂号时间：</van-col>
          <van-col span="18"><span
              style="font-weight: bold;">{{moment(record.regDateTime).format("YYYY-MM-DD HH:mm:ss")}}</span>
          </van-col>
        </van-row>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;" v-if="record.orgName!=null">
          <van-col span="6">院区：</van-col>
          <van-col span="18">{{record.orgName}}
          </van-col>
        </van-row>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;" v-if="record.deptName!=null">
          <van-col span="6">科室：</van-col>
          <van-col span="18">{{record.deptName}}
          </van-col>
        </van-row>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;" v-if="record.doctorName!=null">
          <van-col span="6">医生：</van-col>
          <van-col span="18">{{record.doctorName}}
          </van-col>
        </van-row>
        <van-row style="padding: 5px 0px 5px 0px;border-bottom: 1px #C5C5C5 solid;">
          <van-col span="6">就诊日期：</van-col>
          <van-col span="18"><span>{{moment(record.visitDateTime).format("YYYY-MM-DD")}}</span>
          </van-col>
        </van-row>
        <van-row style="padding: 5px 0px 5px 0px;border-bottom: 1px #C5C5C5 solid;">
          <van-col span="6">就诊时段：</van-col>
          <van-col span="18"><span>{{record.visitFlag}}</span>
          </van-col>
        </van-row>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;" v-if="record.doctorName!=null">
          <van-col span="6">就诊序号：</van-col>
          <van-col span="18">{{record.regOrderNum}}
          </van-col>
        </van-row>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;" v-if="record.regType!=null">
          <van-col span="6">业务类型：</van-col>
          <van-col span="18">{{record.regType}}
          </van-col>
        </van-row>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;" v-if="record.regFee!=null">
          <van-col span="6">金额：</van-col>
          <van-col span="18"><span style="color:#F15C18 ;font-weight: bold;">{{record.regFee}}</span>元
          </van-col>
        </van-row>
        <van-row style="border-bottom: 1px #C5C5C5 solid;padding: 5px 0px 5px 0px;" v-if="record.payType!=null">
          <van-col span="6">支付方式：</van-col>
          <van-col span="18"><span style="text-align: center;" v-if="record.payType=='支付宝'">
              <van-icon name="alipay" color="#1989fa" /></span>
            {{record.payType}}
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>
  </base-container>
</template>
<script>
  import { isLogin } from "@/util/auth";
  import { getUserInfo } from "@/api/customer";
  import { QueryRegisterRecordList } from "@/api/hos";
  import moment from "moment";
  import { Notify } from 'vant';
  export default {
    data() {
      return {
        showList: false,
        isLoading: false,
        user: {
          cusWaterfeeInfos: [],
          cusMedicalCards: [],
        },//患者信息集合
        checkValue: "",
        isLogin: false,//是否已登录系统
        checkUsesMedInfo: {
          patientId: "",
          cardNo: "",
          patientName: ""
        },
        columns: [],
        registerRecordList: []//挂号记录
      }
    },
    created() {
      if (isLogin()) {
        this.isLogin = true;
        this.getUserInfo();
      }
    },
    methods: {
      moment,
      getUserInfo() {
        this.isLoading = true;
        getUserInfo().then(res => {
          //console.log(res.data.value);
          if (res.data.value != null) {
            this.user = res.data.value;
            if (this.user.cusMedicalCards.length > 0) {
              this.user.cusMedicalCards.forEach(c => {
                this.columns.push(c.patientName + "(" + c.cardNo + ")");
              });
              this.checkUsesMedInfo = this.user.cusMedicalCards[0];
              this.checkValue = this.checkUsesMedInfo.patientName + "(" + this.checkUsesMedInfo.cardNo + ")";
            }
          }
          this.isLoading = false;
        });
      },
      registerRecordQuery() {
        this.registerRecordList = [];
        this.isLoading = true;
        if (this.checkUsesMedInfo.patientId != "") {
          var data = {
            PatientId: this.checkUsesMedInfo.patientId,
            StartDate: moment(new Date()).subtract(1, 'months').format("YYYY-MM-DD"),
            EndDate: moment(new Date()).format("YYYY-MM-DD")
          };
          QueryRegisterRecordList(data).then(res => {
            if (res.data.value != null) {
              this.registerRecordList = res.data.value;
            }
            else {
              Notify({
                type: 'danger',
                message: res.data.msg,
                duration: 1000
              });
            }
            this.isLoading = false;
          });
        }
        else {
          this.isLoading = false;
        }
      },
      onConfirm(value, index) {
        this.registerRecordList = [];
        this.checkUsesMedInfo = this.user.cusMedicalCards[index];
        this.checkValue = value;
        this.showList = false;
      },
      onCancel() {
        //Toast('取消');
        this.showList = false;
      }
    }
  }
</script>

<style>
  .cellgrouptop {
    margin: 10px;
  }

  .cellgroup {
    margin: 10px;
  }
</style>